<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{item.title}}</div>
		</div>
		<div class="item_info_bg"></div>
		<div class="block_div item_info info1">
			<div class="title">
				{{$t('invest.taxContent')}}
			</div>
			<div class="detail">
				<van-cell-group :border="false">
					<van-cell :title="$t('invest.taxMoney')" value-class="value_class" :border="false"
						:value="common.currency_symbol_basic()+common.precision_basic(item.money)" />
				</van-cell-group>
			</div>
		</div>
		<div class="block_div item_detail">
			<div class="title">
				{{$t('invest.taxContent')}}
			</div>
			<div class="content" v-html="item.content"></div>
		</div>
		<div v-if="item.status==0" class="basic_btn btn"
			@click="$router.replace('/recharge?type3=2&money='+common.precision_basic(item.money))">
			{{$t('invest.taxPay')}}
		</div>
		<div v-if="item.status==1" class="basic_btn btn color999">
			{{$t('tabs.pending')}}
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import bsHeader from '../../components/bsHeader.vue'
	import Fetch from '../../utils/fetch'
	import * as echarts from 'echarts';
	import {
		Icon,
		Popup,
		Field,
		Cell,
		CellGroup
	} from 'vant';
	Vue.use(Icon).use(Popup).use(Field).use(Cell).use(CellGroup);
	export default {
		name: "",
		components: {
			bsHeader
		},
		data() {
			return {
				data: [],
				item: {
					money: 0,
					status: 1
				},
				loading: false,
			};
		},
		created() {
			if (window.plus) {
				plus.navigator.setStatusBarBackground('#0F6EFF');
				plus.navigator.setStatusBarStyle('light');
			}
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/user/item_tax_detail').then(r => {
					this.item = r.data.item;
				})
			},
			submit() {
				if (this.loading) return false;
				if (this.item.user_balance - this.item.money < 0) {
					this.$toast(this.$t('invest.moneyNotEnough'));
					return false;
				}
				this.loading = true;
				Fetch('/user/tax').then(r => {
					this.$toast(this.$t('invest.taxPaySuccess'));
					setTimeout(() => {
						this.$router.back();
					}, 3000);
				})
			}
		}
	};
</script>

<style lang="less" scoped>
	.basic_wrap {
		margin-bottom: 60px;
	}

	.red_top_bg {
		background: #0F6EFF;
		position: fixed;
		z-index: 10;
		box-shadow: unset;

		.back_left {
			background: url(../img/common/back.png) no-repeat center center;
			width: 30px;
			height: 22px;
		}

		.big_tit {
			color: #FFFFFF;
			left: 55px;
		}
	}

	.item_info_bg {
		background: #0F6EFF;
		width: 100%;
		height: 138px;
		border-radius: 0 0 30px 30px;
	}

	.item_title {
		margin-top: 54px;
		line-height: 2;
		font-size: 16px;
		font-weight: bold;
		padding: 10px 20px;
	}

	.logo {
		margin-bottom: 10px;

		img {
			width: 100%;
		}
	}

	.item_info {
		margin-bottom: 10px;

		.title {
			padding: 15px 0 10px 15px;
			font-size: 16px;
			border-bottom: 1px solid #F7F7F7;
		}

		.detail {
			padding: 10px 0;
			line-height: 2;

			.value_class {
				font-weight: bold;
				color: #3CB371;
			}
		}
	}

	.info1 {
		margin-top: -86px;
	}

	.popup_info {
		.title {
			text-align: center;
			padding: 16px;
		}

		.invest_amount {
			color: #999;
			padding: 15px 20px 0 0;
			font-size: 14px;
		}

		.invest_detail_wrap {
			width: 100%;
			margin: 0;
			justify-content: space-between;
			padding: 15px;
			border-top: 1px solid #F7F7F7;

			.detail_money {
				color: #FF0000;
				font-weight: bold;
				font-size: 16px;
				margin-left: 5px;
			}

			.sbtn {
				width: unset;
				height: unset;
				line-height: unset;
				padding: 5px 15px;
			}
		}
	}

	.item_detail {
		margin-bottom: 20px;

		.title {
			padding: 15px 0 10px 15px;
			font-size: 16px;
			border-bottom: 1px solid #F7F7F7;
		}

		.content {
			padding: 10px 15px 15px 15px;
			line-height: 2;

		}
	}

	.btn {
		position: fixed;
		bottom: 20px;
		width: 80%;
		margin-left: 10%;
	}

	.color999 {
		background: #999;
	}

	/deep/ .van-cell {
		font-size: unset;
		padding: 5px 16px;
	}
</style>
